import { Paper } from "@material-ui/core";
import { DashboardMap } from "../dashboard/DashboardMap";
import "./locations-current/CurrentLocationsView.css";

export const LocationsDashboard = (props: any) => {
  return (
    <div className="dashboard-wrapper disable-overflow">
      <Paper className="map-wrapper">
        <DashboardMap {...props} />
      </Paper>
    </div>
  );
};
